module.exports = __webpack_public_path__ + "static/media/reservation.8dbdf078.svg";